import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { counterAPI } from '../../api/client';

export const incrementAsync = createAsyncThunk(
    'counter/incrementAsync',
    async () => {
        const response = await counterAPI.increment();
        return response.data;
    }
);

export const decrementAsync = createAsyncThunk(
    'counter/decrementAsync',
    async () => {
        const response = await counterAPI.decrement();
        return response.data;
    }
);

export const fetchCounter = createAsyncThunk(
    'counter/fetchCounter',
    async () => {
        const response = await counterAPI.getCurrent();
        return response.data;
    }
);

const counterSlice = createSlice({
    name: 'counter',
    initialState: {
        value: 0,
        loading: false,
    },
    reducers: {
        //эти редьюсеры не используются, так как на фронте мы не считаем данные, а только получаем с бэка
        //и уже инджектим их к себе в состояние через экстра редьюсеры (ниже)
        increment: (state) => {
            state.value += 1;
        },
        decrement: (state) => {
            state.value -= 1;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(incrementAsync.pending, (state) => {
                state.loading = true;
            })
            .addCase(incrementAsync.fulfilled, (state, action) => {
                state.value = action.payload;
                state.loading = false;
            })
            .addCase(decrementAsync.pending, (state) => {
                state.loading = true;
            })
            .addCase(decrementAsync.fulfilled, (state, action) => {
                state.value = action.payload;
                state.loading = false;
            })
            .addCase(fetchCounter.fulfilled, (state, action) => {
                state.value = action.payload;
            });
    },
});

export const { increment, decrement } = counterSlice.actions;
export default counterSlice.reducer;